import React from 'react'

class CheckBoxRow extends React.Component {
  constructor (props) {
    super(props)
    this.selectedClass = "col-xs-2 col-sm-2 tick"
    this.unselectedClass = "col-xs-2 col-sm-2 tick hidden"
  }

  render () {
    return (
      <div className={`check-box ${(this.props.isChecked ? 'active' : '')}`} onClick={this.props.onClickHandler}>
        <div className="row">
          <div className="col-xs-10 col-sm-10">{this.props.text}</div>
          <div className={this.props.isChecked ? this.selectedClass : this.unselectedClass}>
            <i className="ficon-tick pull-right" />
          </div>
          <input
            type="checkbox"
            name={this.props.name}
            ref={this.props.name}
            id={this.props.id}
            defaultChecked={this.props.isChecked ? 'checked' : ''} value={this.props.value}
            data-subcategory-id={this.props['data-subcategory-id']}
            className="form-control invisible"
          />
          </div>
        </div>
        )
     }
 }

export default CheckBoxRow
